module.exports = __webpack_public_path__ + "1a0c6ddbae838e701f3b1a20c64e7aae.mp3";